import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'
import yn from 'yn'

const AlertMessage = ({ isMessageOpened, messageText, closeAlertMessage }) => {
  return (
    <div
      className={`container-fluid pos-fixed bg-featured alert-message ${!yn(isMessageOpened) && 'd-none'}`}
      role='alert'
      aria-atomic='true'
    >
      <div className='container container-message'>
        <div className='row'>
          <div className='col-auto d-flex align-items-center pr-0'>
            <Icon
              iconName='icon_warning'
              className='icon-sm mr-1 color-title'
            />
          </div>
          <div className='col d-flex align-items-center px-0'>
            <p className='color-title'>{messageText}</p>
          </div>
          <div className='col-auto d-flex align-items-center pl-0'>
            <Icon
              iconName='icon_close'
              className='icon-sm mr-1 color-title ponter'
              role='button'
              onClick={closeAlertMessage}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

AlertMessage.propTypes = {
  isMessageOpened: PropTypes.bool,
  messageText: PropTypes.string,
  closeAlertMessage: PropTypes.func
}

export default AlertMessage



// WEBPACK FOOTER //
// ./src/App/Header/AlertMessage.js